export default __webpack_public_path__ + "static/Melissani-credit-MichalKosacky-90d7a0674cdf55151f74c8f09bebde3b.jpg";